import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Button,
    ButtonGroup,
} from '@chakra-ui/react';
import { useRef } from 'react';

interface Options {
    label: string;
    callback: (...args: any[]) => void;
    useCloseCallBack: boolean;
    isCancel: boolean;
}

interface Props {
    isConfirmOpen: boolean;
    prompt: string;
    title: string;
    onOpenCallback: any;
    onCloseCallback: any;
    options: Options[];
}

export const ConfirmationAlert: React.FC<Props> = ({
    isConfirmOpen,
    prompt,
    title,
    onCloseCallback,
    options,
}) => {
    const cancelRef = useRef<HTMLButtonElement>(null);
    return (
        <AlertDialog
            isOpen={isConfirmOpen}
            leastDestructiveRef={cancelRef}
            onClose={onCloseCallback}
            isCentered
            motionPreset="slideInBottom"
        >
            <AlertDialogOverlay>
                <AlertDialogContent>
                    <AlertDialogHeader fontSize="lg" fontWeight="bold">
                        {title}
                    </AlertDialogHeader>
                    <AlertDialogBody>{prompt}</AlertDialogBody>
                    <AlertDialogFooter>
                        <ButtonGroup>
                            {options.map(({ label, callback, useCloseCallBack, isCancel }, idx) => {
                                return (
                                    <Button
                                        onClick={() => {
                                            callback();
                                            if (useCloseCallBack) {
                                                onCloseCallback();
                                            }
                                        }}
                                        ref={isCancel ? cancelRef : null}
                                        key={idx}
                                    >
                                        {label}
                                    </Button>
                                );
                            })}
                        </ButtonGroup>
                    </AlertDialogFooter>
                </AlertDialogContent>
            </AlertDialogOverlay>
        </AlertDialog>
    );
};
